export default __webpack_public_path__ + "static/media/header.a372b353.jpg";